import { Controller } from "@hotwired/stimulus"

// Floating flash toast. Lives out of document flow (fixed) so it never pushes
// page content down — it slides/fades in, auto-dismisses, pauses on hover, and
// can be closed manually.
export default class extends Controller {
  static values = { delay: { type: Number, default: 4500 } }

  connect() {
    // Reveal on the next frame so the enter transition actually runs.
    requestAnimationFrame(() => this.element.classList.remove("opacity-0", "-translate-y-2"))
    this.scheduleDismiss()
  }

  disconnect() {
    this.clearTimer()
  }

  scheduleDismiss() {
    if (this.delayValue <= 0) return
    this.timer = setTimeout(() => this.dismiss(), this.delayValue)
  }

  clearTimer() {
    if (this.timer) clearTimeout(this.timer)
  }

  // Hovering pauses the auto-dismiss; leaving restarts the countdown.
  hold() {
    this.clearTimer()
  }

  release() {
    this.scheduleDismiss()
  }

  dismiss() {
    this.clearTimer()
    this.element.classList.add("opacity-0", "-translate-y-2")
    this.element.addEventListener("transitionend", () => this.element.remove(), { once: true })
  }
}
